import React from "react";
import "./styles.scss";
import { IconCheckCircleFill } from "@amzn/stencil-react-components/icons";
import { HVH_COLORS } from "../../config/palette";
import { H3 } from "../typography";
import { Col, Flex } from "@amzn/stencil-react-components/layout";
import useArb from "../../hooks/use-arb";

interface StepProgressBarProps {
  steps: Array<Step>;
}

export interface Step {
  name: string;
  isCompleted: boolean;
  isActive: boolean;
}

function processStepName(stepName: string) {
  if (stepName == "First day") {
    return "Checklist-ApplicationSteps-FirstDay";
  } else {
    return "Checklist-ApplicationSteps-" + stepName;
  }
}

export const StepProgressBar = ({ steps }: StepProgressBarProps) => {
  const bundle = useArb("HVHChecklistPantherResource");
  return (
    <>
      <Flex flexDirection="row" className="stepper-wrapper" justifyContent="center" alignItems="center">
        {steps.map((step, index) => (
          <Col
            gridGap={"0.3rem"}
            key={step.name + index}
            className={`stepper-item ${step.isCompleted ? "completed" : step.isActive ? "active" : ""}`}
          >
            <Col className="step-name">
              <H3 fontSize="T200" {...(step.isActive && { fontWeight: "bold" })}>
                {bundle.getMessage(processStepName(step.name))}
              </H3>
            </Col>
            <Col className="step-counter">
              <IconCheckCircleFill color={`${step.isCompleted ? HVH_COLORS.PRIMARY_70 : HVH_COLORS.NEUTRAL_20}`} />
            </Col>
          </Col>
        ))}
      </Flex>
    </>
  );
};
